import _asyncToGenerator from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useOauth } from '@peloton/auth';
import { captureException } from '@webtv/error-reporting-v2';

var useAuthorizationHeader = function useAuthorizationHeader(client) {
  var _useOauth = useOauth(),
      getAccessTokenSilently = _useOauth.getAccessTokenSilently;

  var router = useRouter();
  useEffect(function () {
    // We should not be making auth calls on pages where we know we will be logged out
    if (!router.pathname.includes('reset-password')) {
      var attachAuthorizationHeaderWithOauth = client.interceptors.request.use( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
          var accessToken;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return getAccessTokenSilently();

                case 3:
                  accessToken = _context.sent;

                  if (accessToken) {
                    config.headers['Authorization'] = "Bearer ".concat(accessToken);
                  }

                  _context.next = 10;
                  break;

                case 7:
                  _context.prev = 7;
                  _context.t0 = _context["catch"](0);

                  // Do not capture errors on the welcome/subscription pages because these errors are expected
                  if (!router.pathname.includes('/welcome') && !router.pathname.includes('/subscription')) {
                    captureException(_context.t0, {
                      isAccessTokenFailure: true,
                      request: config
                    });
                  }

                case 10:
                  return _context.abrupt("return", config);

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 7]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      return function () {
        return client.interceptors.request.eject(attachAuthorizationHeaderWithOauth);
      };
    }

    return function () {
      return null;
    };
  }, [getAccessTokenSilently, client.interceptors.request, router === null || router === void 0 ? void 0 : router.pathname]);
};

export default useAuthorizationHeader;